import { defineComponent } from '~/scripts/utils/alpine'

export interface GatedDownloadOptions {
  openOnInit?: boolean
  completedOnInit?: boolean
}

export default defineComponent((options?: GatedDownloadOptions) => ({
  triggerElement: undefined as HTMLElement | undefined,
  completed: options?.completedOnInit || false,
  init() {
    this.triggerElement =
      (this.$root.querySelector('[aria-controls]') as HTMLElement | null) ||
      undefined

    if (options?.openOnInit) {
      this.$nextTick(() => this.open())
    }
  },
  getDialog() {
    return this.$refs.dialog as HTMLDialogElement
  },
  open(trigger?: HTMLElement) {
    const dialog = this.getDialog()
    this.triggerElement = trigger || this.triggerElement

    if (!dialog.open) {
      dialog.showModal()
      document.documentElement.classList.add('overflow-hidden')
    }
  },
  close() {
    const dialog = this.getDialog()
    if (dialog.open) dialog.close()
  },
  trigger: {
    '@click'(event: MouseEvent) {
      this.open(event.currentTarget as HTMLElement)
    },
    ':aria-haspopup'() {
      return 'dialog'
    },
  },
  dialog: {
    '@click'(event: MouseEvent) {
      if (event.target === this.$el) this.close()
    },
    '@close'() {
      document.documentElement.classList.remove('overflow-hidden')
      this.completed = false
      this.triggerElement?.focus()
    },
  },
  confirmation: {
    'x-show'() {
      return this.completed
    },
  },
  form: {
    'x-show'() {
      return !this.completed || this.$el.dataset.showWithConfirmation === '1'
    },
  },
  closeButton: {
    '@click'() {
      this.close()
    },
  },
}))
